<template>
  <div class="content">
    <PageHeader :title="$t('invoices.header')" />
    <div class="page-content container-fluid">
      <div class="row">
        <div class="col-3">
          <BalanceCard />
        </div>
        <div class="col-9">
          <InvoicesCard />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <plans-card />
        </div>
        <div v-if="false" class="col-lg-6">
          <BillingSettingsCard />
        </div>
        <div v-if="false" class="col-lg-6">
          <div class="card">
            <div class="card-header header_options">
              <div class="card-title header_title">
                <span class="material-symbols-outlined">build_circle</span><span class="m-left-10">{{ $t('billing.prefs.header') }}</span>
              </div>
            </div>
            <div>
              <b style="color: var(--gray-font-color-2); margin-bottom: 20px;display: block;">Endereço de cobrança</b>
              <div class="card-address">
                <span class="material-symbols-outlined place-icon">place</span>
                <p class="card-text">
                  <span style="color: #9ca7b0">Av São João, 473 Loja 03<br />Centro, Peruíbe - SP<br />11750-000</span>
                </p>
                <img class="img-right" src="@/assets/place_icon.png" />
                <div style="clear:both;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment';
import PageHeader from '@/components/PageHeader.vue';
import InvoicesCard from '@/components/cards/InvoicesCard.vue';
import PlansCard from '@/components/rebranding/cards/PlansCard.vue';
import BalanceCard from '@/components/cards/BalanceCard.vue';
import BillingSettingsCard from '@/components/cards/BillingSettingsCard.vue';

export default {
  name: 'Billing',
  components: {
    PageHeader,
    InvoicesCard,
    PlansCard,
    BalanceCard,
    BillingSettingsCard,
  },
  data() {
    return {
      invoices: {},
      loaded: false,
      months: [],
      date: '',
      usage: [],
      percent: 10,
      openInvoices: 0,
      options: {
        timePicker: false,
        autoApply: true,
        className: 'form-control',
        maxSpan: {
          days: 31,
        },
        locale: {
          format: 'DD/MM/YYYY',
          daysOfWeek: ['Do', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sa'],
          monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Otu', 'Nov', 'Dez'],
        },
      },
      form: {
        date: {
          gte: moment().format('YYYY-MM-DD'),
          lte: moment().format('YYYY-MM-DD'),
        },
      },
    };
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
  },
  created() {},
  methods: {
    // changeOpenInvoices(invoices) {
    //   invoices.forEach((invoice) => {
    //     console.log(invoice);
    //     if (invoice.status === 'pending') {
    //       this.openInvoices += 1;
    //     }
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
.bg-balance {
  background-color: #38e08c;
}
.card-deck .card:not(.card-deck .card.bg-balance) {
  /* flex: 0 0 20%; */
  flex: 1;
}

.invoices-card p {
  color: #521e66 !important;
}

.invoices-closing-card p,
.invoices-closing-card span {
  color: #6eda2c !important;
}

.invoices-type-card p,
.invoices-type-card span {
  color: #ffc000 !important;
}

.rebranding .card {
  height: 100%;
}

.col-lg-6 {
  margin-bottom: 2rem;
}

.infos-wrapper .card-deck .container-fluid,
.infos-wrapper .card-deck .container-fluid .row {
  height: 100%;
}

.infos-desc {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

@media (min-width: 768px) {
  .card-deck .card {
    max-width: 23.333%;
  }
}

@media (max-width: 767.98px) {
  .card-deck {
    padding-right: 15px;
    padding-left: 15px;
  }
}

@media (min-width: 1360px) and (max-width: 1600px) {
  .infos-desc {
    padding-left: 10px;
  }
  .card-deck .card {
    flex: 1 !important;
  }
}
.card-invoice-success {
  background: #16cd0854;
  box-shadow: none;
  border: solid 1px #e4e7ec;
  border-radius: 8px;
  padding: 16px;
}
.card-invoice-success h4 {
  color: #000000 !important;
}
.card-invoice-success p {
  color: #000000 !important;
}
.agentes-card {
  border: #e4e7ec solid 1px;
  box-shadow: none;
  padding: 10px;
  border-radius: 8px;
}
.invoices-type-card {
  border: #e4e7ec solid 1px;
  box-shadow: none;
  padding: 10px;
  border-radius: 8px;
}
.card {
  margin-bottom: 10px;
}
.btn-add-balance {
  border: none;
}
.btn-add-balance {
  background: #d2f9cf;
  padding: 6px 24px 6px 24px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.btn-add-balance {
  color: #16cd08;
}
.btn-add-balance span {
  color: #16cd08;
}
.invoices-card {
  border: #e4e7ec solid 1px;
  box-shadow: none;
  padding: 10px;
  border-radius: 8px;
  padding-bottom: 0px;
  height: auto !important;
}
.invoices-card strong {
  color: #000000 !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}
.invoices-card p {
  color: #707070 !important;
}
.card-header {
  margin-bottom: 15px;
}
.rebranding .card .opts_card i {
  font-size: 22px;
  transition: 0.5s;
  padding: 5px;
}

.rebranding .card .opts_card i:hover {
  background-color: var(--background-icon-hover);
  border-radius: 5px;
}
.card {
  box-shadow: none;
}
.card-header {
  border-bottom: #6b23dc3d 4px solid !important;
  padding: 0px;
  padding-bottom: 5px;
}
.card-header .card-title {
  color: #697077 !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  margin-top: 10px !important;
}
.header_title {
  display: flex;
  color: #697077 !important;
  font-size: 16px !important;
  font-weight: 400 !important;
}
.card-header input {
  height: 30px !important;
}
.card-header button {
  height: 30px !important;
}
.m-left-10 {
  margin-left: 10px;
}
.card-address {
  border: #e4e7ec solid 1px;
  box-shadow: none;
  padding: 10px;
  border-radius: 8px;
  display: block;
}
.place-icon {
  margin-top: 20px;
  margin-right: 15px;
  margin-left: 10px;
}
.card-address span {
  float: left;
}
.card-address p {
  float: left;
  margin-bottom: 0;
}
.img-right {
  width: 70px;
  height: 70px;
  float: right;
}
.divider-credit {
  height: 4px;
  background: #b2efae;
  width: 90%;
  border-radius: 8px;
  margin: 0 auto;
  margin-bottom: 2px;
}
</style>
